import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const translationPath = (baseUrl: string, locale: string) =>
  `${baseUrl}assets/locale/productWidget/productWidget_${locale}.json`;

export const FormFactor = {
  Desktop: 'Desktop',
  Mobile: 'Mobile',
  Tablet: 'Tablet',
} as const;

export type FormFactorType = (typeof FormFactor)[keyof typeof FormFactor];

export const origin = 'product-widget';
export const DEFAULT_IMAGE_DEFAULT_SIZE = '80';
export const SPECS = {
  ...SdkSpecs,
  EDITOR_OOI: 'specs.stores.EditorOOI',
  SHOW_AUTOMATIC_DISCOUNT_DATA_ON_PRODUCT_WIDGET: 'specs.stores.ShowAutomaticDiscountDataOnProductWidget',
  SHOULD_USE_COMMON_DISCOUNT_PRICING_METHODS: 'specs.stores.ShouldUseCommonDiscountPricingMethods',
  SHOULD_USE_NEW_DEFAULT_PRODUCT_IMAGE: 'specs.stores.UseNewDefaultProductImage',
  ENABLE_PANORAMA_INTEGRATION: 'specs.stores.StorefrontLegacyEnablePanoramaIntegration',
  LOAD_CLIENT_CONFIG_IN_LEGACY_CONTROLLER: 'specs.stores.LoadClientConfigInLegacyController',
  APP_REFLOW_PRODUCT_WIDGET_NAVIGATION: 'specs.stores.AppReflowProductWidgetNavigation',
  USE_EXPERIMENTS_FROM_PLATFORM: 'specs.stores.UseExperimentsFromPlatformFlowApiLegacyProjects',
};

export const MULTILINGUAL_TO_TRANSLATIONS_MAP = {
  NAVIGATE_TO_PRODUCT_PAGE_BUTTON: 'PRODUCT_WIDGET_BUTTON_TEXT',
  ADD_TO_CART_BUTTON: 'PRODUCT_WIDGET_BUTTON_TEXT',
  OUT_OF_STOCK: 'PRODUCT_WIDGET_BUTTON_OOS_TEXT',
};
